import { createSelector } from "@reduxjs/toolkit";
import { Store } from "./loader.store";
const getLoadingFeature = (state) => state[Store.featureKey];
export const getIsActionLoading = (actions) => createSelector(getLoadingFeature, (loadingState) => {
    if (Array.isArray(actions)) {
        return actions.some(({ type }) => Boolean(loadingState[type]));
    }
    else {
        return Boolean(loadingState[actions.type]);
    }
});
export const getIsAnyActionLoading = createSelector(getLoadingFeature, (loadingState) => Boolean(Object.entries(loadingState).length));
